import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import cn from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectDeviceType } from '../../../redux/selectors';
import { Theme } from '../../../types/Theme';
import { DH } from '../../../utils/DataHook';
import * as s from './styles.scss';

export interface PaymentMethodItemProps {
  label: string;
  icon?: React.ReactElement;
  paymentMethodId: PaymentMethod;
  isSelected: boolean;
  theme?: string;

  onClick(): void;
}

export const PaymentMethodItem: React.FunctionComponent<PaymentMethodItemProps> =
  (props) => {
    const handleClick = (e) => {
      e.stopPropagation();
      e.preventDefault();

      props.onClick();
    };
    const deviceType = useSelector(selectDeviceType);

    return (
      <label
        className={cn({
          [s.paymentMethod]: true,
          [s.creditCard]: props.paymentMethodId === PaymentMethod.CreditCard,
          [s.mobile]: deviceType === 'mobile',
          [s.withBorder]: props.isSelected && props.theme === Theme.accordion,
        })}
        data-hook={DH.MethodsList.Item.Container}
        data-payment-method-id={`wcn-payment-method-item-${props.paymentMethodId}`}
        htmlFor={props.paymentMethodId}
        aria-label={props.label}
        role="radio"
        aria-checked={props.isSelected ? 'true' : 'false'}
        onClick={handleClick}
      >
        <div className={s.radioContainer}>
          <input
            className={s.paymentMethodInput}
            type="radio"
            name="paymentMethodSelection"
            id={props.paymentMethodId}
            checked={props.isSelected}
            value={props.paymentMethodId}
            aria-label={props.label}
            aria-checked={props.isSelected}
            tabIndex={-1}
            onChange={() => null} // fix React error with checked prop without onChange handler
            data-hook={DH.MethodsList.Item.Radio(props.paymentMethodId)}
          />
          <i role="presentation" />
          <span data-hook={DH.MethodsList.Item.Title} aria-hidden="true">
            {props.label}
          </span>
        </div>
        <div className={s.icon}>{props.icon}</div>
      </label>
    );
  };
PaymentMethodItem.displayName = 'PaymentMethodItem';
